import Vue from 'vue'
import Router from 'vue-router'
import { routes } from './routes'
// import store from '@/store'
// import { setCookie, getCookie, getLang } from '@/util'
// import { checkDefaultLanguage } from '@/i18n'

Vue.use(Router)

if (process.env.NODE_ENV !== 'production') {
  const html = require('./html.js')
  routes.push(html.default)
}

const router = new Router({
  mode: 'history',
  scrollBehavior (to, from, savedPosition) {
    // if ((to.meta.scroll && to.params.child) || to.query.size === 'mobile' || to.name === 'NewsroomSearch') {
    //   return savedPosition
    // }
    //
    // if (to.meta.scroll && !isNaN(Number(to.params.category))) {
    //   return savedPosition
    // }
    //
    // if (to.path.indexOf('/newsroom') > -1 && to.meta.scroll && to.name !== from.name) {
    //   return savedPosition
    // }
    //
    // if (to.path.indexOf('/sustainability') > -1) {
    //   return savedPosition
    // }

    // const fromName = from.matched.length > 0 ? from.matched[0].name : to.matched[0].name
    //
    // if (to.matched.length > 1 && to.matched[0]?.name === fromName) {
    //   return savedPosition
    // }

    const navigationTab = document.querySelector('.navigation-tab')

    if (savedPosition) {
      return savedPosition
    } else {
      if (navigationTab && to.query.sub === 0) {
        return {
          x: 0,
          y: navigationTab.offsetTop
        }
      } else {
        return {
          // x: 0,
          y: 0
        }
      }
    }

    // return savedPosition
  },
  routes
})

// router.beforeEach((to, from, next) => {
//   if (to.params.locale) {
//     store.commit('locale/UPDATE_LOCALE', to.params.locale)
//   }
//
//   const cookieLang = getCookie('lang') === 'KR' ? 'ko' : 'en'
//   if (cookieLang !== to.params.locale) {
//     const newLocale = to.params.locale === 'en' ? 'EN' : 'KR'
//     setCookie('lang', newLocale)
//   }
//
//   const locale = checkDefaultLanguage() || 'ko'
//   const localLang = window.localStorage.getItem('lang')
//
//   if (localLang) {
//     if (localLang === 'en' && !window.location.pathname.includes('/en')) {
//       if (to.params.locale !== 'en') {
//         next({
//           name: to.name,
//           params: {
//             ...to.params,
//             locale: locale
//           },
//           query: to.query
//         })
//       }
//     }
//
//     // if (localLang === 'ko' && window.location.pathname.includes('/en')) {
//     //   if (to.params.locale !== '') {
//     //     next({
//     //       name: to.name,
//     //       params: {
//     //         ...to.params,
//     //         locale: ''
//     //       },
//     //       query: to.query
//     //     })
//     //     // window.location.reload()
//     //   }
//     // }
//   } else {
//     window.localStorage.setItem('lang', locale)
//
//     if (locale === 'en') {
//       next({
//         name: to.name,
//         params: {
//           locale: locale
//         }
//       })
//     }
//   }
//
//   next()
// })

export default router
